// extracted by mini-css-extract-plugin
export default {"wrapper":"TitleAndDesc_wrapper__rnXqJ","title":"TitleAndDesc_title__JYdLr","description":"TitleAndDesc_description__HYVWx"};